import { ThreadSlug } from "@twinkltech/curriculum-architect-domain-hooks";

import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const getThreadSlugTranslations = (threadSlugs?: ThreadSlug[]) => {
  return threadSlugs
    ? threadSlugs.map((slug) => i18n.t(`threads.${slug}`, { ns: COMMON_NS }))
    : [];
};
